/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Checkbox, Popover } from "alurkerja-ui";
import { ListFilter } from "lucide-react";
import { useState } from "react";

const rfsSubmissions = [
  "PREPARATION_DATA",

  "REJECTED_DOCUMENT_RFS",

  "REVIEW_BY_LN",

  "CANCELED",

  "REVISION_DATA",
];

type ValueOption = string | number;

export default function StatusFilterComponent({
  listOptions,
  defaultFilterValue,
  name,
  handleChangeFilterByColumns,
  paramName,
}: {
  listOptions?: { label: string; value: ValueOption }[];
  handleChangeFilterByColumns: (key: string, value: any) => void;
  defaultFilterValue: any;
  name: string;
  paramName?: string;
}) {
  const [status, setStatus] = useState<ValueOption[]>([]);
  const [statusLabel, setStatusLabel] = useState<ValueOption[]>([]);
  const [open, setOpen] = useState<boolean | undefined>(false);

  const defaultValue = defaultFilterValue?.[name] ?? undefined;
  const defaultLmsValue =
    defaultFilterValue?.["statusRfsSubmissionLmsValues"] ?? undefined;

  const arrayDefaultValue = [
    ...(typeof defaultValue === "string"
      ? defaultValue?.split(",") ?? []
      : defaultValue ?? []),
    ...(typeof defaultLmsValue === "string"
      ? defaultLmsValue?.split(",") ?? []
      : defaultLmsValue ?? []),
  ];

  function handleChanges(value: ValueOption[] | null) {
    // change value to label form listOptions
    const selectedLabels = value?.map((val: ValueOption) => {
      const option = listOptions?.find((opt) => opt.value === val);
      return option ? option.label : val;
    });
    setStatus(value ?? []);
    setStatusLabel(selectedLabels ?? []);
  }

  return (
    <Popover
      triggerElement={
        <Button
          size="xs"
          className="flex w-44 items-center justify-between bg-slate-100 py-3"
        >
          <span className="overflow-hidden text-sm text-slate-500">
            <p className="truncate text-ellipsis text-sm">
              {statusLabel.length > 0 ? (
                <span className="text-black">{statusLabel.join(", ")}</span>
              ) : (
                "Filter"
              )}
            </p>
          </span>
          <span>
            <ListFilter size={12} />
          </span>
        </Button>
      }
      open={open}
      setOpen={setOpen}
      positionOverlay={["bottom", "left", "right", "top"]}
      content={
        <div className="flex flex-col gap-1 rounded p-3 shadow">
          <div className="max-h-[300px] overflow-y-auto p-1">
            <Checkbox
              className="flex flex-col gap-2"
              listOption={listOptions}
              onChange={handleChanges}
              defaultValue={status || ""}
            />
          </div>
          <div className="mt-3 flex justify-end">
            <Button
              size="xs"
              className="w-full bg-axiata-blue text-white"
              type="button"
              onClick={() => {
                if (paramName) {
                  handleChangeFilterByColumns(paramName, status);
                } else {
                  const statusRfsSubmissions = status.filter((item) =>
                    rfsSubmissions.includes(item.toString()),
                  );
                  const statusRfsLms = status.filter(
                    (item) => !rfsSubmissions.includes(item.toString()),
                  );

                  handleChangeFilterByColumns(name, statusRfsSubmissions);
                  handleChangeFilterByColumns(
                    "statusRfsSubmissionLmsValues",
                    statusRfsLms,
                  );
                }
                setOpen(false);
              }}
              disabled={status.length === 0}
            >
              Apply
            </Button>
          </div>
          <div className="flex justify-end">
            <Button
              size="xs"
              className="w-full bg-slate-200"
              type="button"
              onClick={() => {
                if (paramName) {
                  handleChangeFilterByColumns(paramName, []);
                } else {
                  handleChangeFilterByColumns(name, []);
                  handleChangeFilterByColumns(
                    "statusRfsSubmissionLmsValues",
                    [],
                  );
                }
                setStatus([]);
                setStatusLabel([]);
                setOpen(false);
              }}
              disabled={
                (arrayDefaultValue?.length === 0 || !arrayDefaultValue) &&
                status.length === 0
              }
            >
              Reset
            </Button>
          </div>
        </div>
      }
    />
  );
}
